import { ProductStoreProvider } from "./provider/ProductStoreProvider"
import { ProductVIPHead } from "./components/ProductVIPHead"
import { ProductView } from "./components/ProductView"
import { useEffect } from "react"

type ProductVIPProps = {
  productId: string
  urlTitle: string
}

export function ProductVIP({ productId, urlTitle }: ProductVIPProps) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <ProductStoreProvider>
      <ProductVIPHead />
      <ProductView productId={productId} urlTitle={urlTitle} />
    </ProductStoreProvider>
  )
}
